import React, { useEffect, useState } from "react";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";
import blog from "../../assets/images/Blog/Blog_Back.jpg";
import MainBtn from "../repeats/mainBtn/MainBtn";
import { getContent } from "../../redux/API/content/content.action";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import ShowMoreText from "react-show-more-text";
import logo from "../nav/Logo";

const PostFull = () => {
  const content = useSelector((state) => state.content);
  const { id } = useParams();
  const [post, setPost] = useState({});
  const dispatch = useDispatch();
  // const [start, setStart] = useState(true);
  // useEffect(() => {
  //   if (start) document.querySelector(".start").scrollIntoView();
  //   setStart(false);
  // }, []);
  useEffect(() => {
    if (!Object.keys(content).length) {
      dispatch(getContent());
    } else {
      let post = content.list.find(
        (item) =>
          item.categories.length > 0 &&
          item.categories[0].title === "blog" &&
          item.id === Number(id)
      );

      setPost(post);
    }
  }, [content]);
  useEffect(() => { }, [post]);
  return (
    <>
      <div className="transport">
        <div className="page_banner page_banner__fixed">
          <img src={blog} alt="" className='blogBanner' />
          <div className="banner_content">
            <div className="banner_title">
              <h1>הבלוג שלנו</h1>
            <div>בחר את השירות שברצונך להזמין</div>
            </div>
            <div className="btnDiv">
              <MainBtn text="הובלה" link="/transport" />
              <MainBtn text="אחסנה" link="/storage" isLight={true} />
            </div>
          </div>
        </div>
      </div>
      <div className="blogFullPost start">
        <h1>{post?.title}</h1>
        <div>
          <img className="fullPostImg" src={post?.image} alt="" />
        </div>
        <div className="fullPostArticleText">
          <div dangerouslySetInnerHTML={{ __html: post?.content }} />
        </div>
        <Link to={"/blog"}>חזרה לבלוג</Link>
      </div>
      <Reviews />
      <Footer isContact={true} />
    </>
  );
};

export default PostFull;
